import BaseService from "src/packages/BaseService";

export default class OrganizationService extends BaseService {
	static get className () {
		return "organization";
	}

	static async getCurrent () {
		const response = await BaseService.getService().get("current");
		return response.data;
	}
}
